import styled, { keyframes } from 'styled-components';

const ldsDefault = keyframes`
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }
`;

const WrapperCircularLoader = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  top: -16px;

  & div {
    animation: ${ldsDefault} 1.2s linear infinite;
    border-radius: 50%;
    height: 6px;
    position: absolute;
    width: 6px;

    &:nth-child(1) {
      animation-delay: 0s;
      left: 66px;
      top: 37px;
    }

    &:nth-child(2) {
      animation-delay: -0.1s;
      left: 62px;
      top: 22px;
    }

    &:nth-child(3) {
      animation-delay: -0.2s;
      left: 52px;
      top: 11px;
    }

    &:nth-child(4) {
      animation-delay: -0.3s;
      left: 37px;
      top: 7px;
    }

    &:nth-child(5) {
      animation-delay: -0.4s;
      left: 22px;
      top: 11px;
    }

    &:nth-child(6) {
      animation-delay: -0.5s;
      left: 11px;
      top: 22px;
    }

    &:nth-child(7) {
      animation-delay: -0.6s;
      left: 7px;
      top: 37px;
    }

    &:nth-child(8) {
      animation-delay: -0.7s;
      left: 11px;
      top: 52px;
    }

    &:nth-child(9) {
      animation-delay: -0.8s;
      left: 22px;
      top: 62px;
    }

    &:nth-child(10) {
      animation-delay: -0.9s;
      left: 37px;
      top: 66px;
    }

    &:nth-child(11) {
      animation-delay: -1s;
      left: 52px;
      top: 62px;
    }

    &:nth-child(12) {
      animation-delay: -1.1s;
      left: 62px;
      top: 52px;
    }
  }
`;

export { WrapperCircularLoader };
